(function () {
  'use strict';
  var icons = [
    '<rect x="4" y="3" width="16" height="18" rx="2"/><path d="m8 15 7-7 2 2-7 7H8v-2z"/>',
    '<path d="M5 3h12l4 4v14H3V3h2zM7 3v6h9V3M7 21v-8h10v8"/>',
    '<path d="M21 11a8 8 0 0 1-8 8H7l-5 3 2-6a8 8 0 1 1 17-5zM7 9h10M7 13h7"/>'
  ];
  function icon(index) { return '<span class="planning-guide__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + icons[index] + '</svg></span>'; }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function labelField(label, value) {
    if (!label) return;
    var node = Array.from(label.childNodes).find(function (child) { return child.nodeType === 3 && child.textContent.trim(); });
    if (node) node.textContent = value + ' ';
  }
  function init() {
    document.querySelectorAll('[data-planning-guide="account"]').forEach(function (guide) {
      guide.innerHTML = '<h2>Schattenwände gemeinsam planen</h2><ol class="planning-guide__steps">'
        + '<li>' + icon(0) + '<div><strong>1. Wand bearbeiten</strong><p>Wand öffnen. Gerät anklicken und auf der Wand verschieben.</p></div></li>'
        + '<li>' + icon(1) + '<div><strong>2. Änderungen speichern</strong><p>„Änderungen speichern“ klicken und auf die Bestätigung achten.</p></div></li>'
        + '<li>' + icon(2) + '<div><strong>3. Im Team abstimmen</strong><p>Änderungsnotiz an der Wand speichern. Rückfragen im Verlauf klären.</p></div></li></ol>';
    });
    var grid = document.getElementById('sbc-drafts-grid');
    function enhanceCard(card) {
      var custom = card.querySelector('[data-draft-name]'), name = custom || card.querySelector('[data-plan-name]');
      if (!name) return;
      var notes = card.querySelector('[data-draft-special-info], [data-plan-notes]');
      var button = card.querySelector('[data-draft-action="open"], [data-plan-edit]');
      var title = card.querySelector('[data-draft-title]');
      if (!card.dataset.planningEnhanced) {
        card.dataset.planningEnhanced = 'true';
        if (button && title) { button.classList.add('planning-card-edit'); text(button, custom ? 'Wand bearbeiten' : 'Planung bearbeiten'); title.after(button); }
        if (custom) {
          var image = card.querySelector('img'), wrapper = image && image.parentElement;
          if (wrapper && wrapper.tagName !== 'BUTTON') {
            var preview = document.createElement('button'); preview.type = 'button'; preview.className = 'planning-card-preview';
            preview.dataset.draftAction = 'open'; preview.dataset.draftId = card.dataset.draftCard;
            preview.setAttribute('aria-label', name.value + ' bearbeiten'); preview.appendChild(image); wrapper.replaceWith(preview);
          }
        }
        var state = document.createElement('p'); state.className = 'planning-card-status'; state.setAttribute('role', 'status'); state.dataset.planningCardStatus = '';
        if (button) button.after(state); else card.appendChild(state);
        if (notes) {
          labelField(notes.closest('label'), 'Hinweise für Angebot & Fertigung');
          notes.placeholder = 'z. B. anderen Besen verwenden, mehr Platz lassen oder Montage abstimmen';
          var hint = document.createElement('p'); hint.className = 'planning-field-hint';
          hint.textContent = 'Vorgaben für die Ausführung hier speichern. Änderungen im Team unten dokumentieren.';
          notes.before(hint);
        }
      }
      var status = card.querySelector('[data-planning-card-status]');
      var dirty = [name, notes].some(function (input) { return input && input.value !== String(input.dataset.originalValue || ''); });
      var savedFields = String(name.dataset.originalValue || '') + '\n' + String(notes && notes.dataset.originalValue || '');
      var updated = card.querySelector('[data-draft-updated]');
      if (card._planningSavedFields != null && card._planningSavedFields !== savedFields && updated) {
        text(updated, new Date().toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }));
      }
      card._planningSavedFields = savedFields;
      var date = updated ? updated.textContent : '';
      if (status) {
        var value = dirty ? 'Änderungen an Name oder Hinweisen noch nicht gespeichert.' : '✓ Im Kundenkonto gespeichert' + (date ? ' · ' + date : '');
        if (status.dataset.state !== (dirty ? 'dirty' : 'saved')) status.dataset.state = dirty ? 'dirty' : 'saved';
        text(status, value);
      }
    }
    if (grid) {
      var refreshQueued = false;
      function refresh() { refreshQueued = false; grid.querySelectorAll('[data-draft-card]').forEach(enhanceCard); }
      refresh();
      new MutationObserver(function () { if (!refreshQueued) { refreshQueued = true; queueMicrotask(refresh); } }).observe(grid, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-original-value'] });
      grid.addEventListener('input', function (event) { var card = event.target.closest('[data-draft-card]'); if (card) enhanceCard(card); });
    }
    var bottomBar = document.getElementById('sbc-bottombar');
    var summary = bottomBar && bottomBar.querySelector('.sbc-bottombar__design-summary');
    if (summary) {
      var status = document.createElement('div'); status.className = 'planning-save-status'; status.dataset.state = 'new';
      status.innerHTML = '<span class="planning-save-status__text" role="status" aria-live="polite">Speichern löst keine Bestellung aus.</span>';
      summary.appendChild(status);
      function update(event) {
        var state = event.detail || {};
        status.dataset.state = state.state || 'new';
        var date = state.savedAt ? new Date(state.savedAt).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' }) : '';
        var labels = { new: 'Speichern löst keine Bestellung aus.', dirty: '', saving: 'Wird im Kundenkonto gespeichert …', saved: '✓ Im Kundenkonto gespeichert' + (date ? ' · ' + date : ''), error: 'Speichern fehlgeschlagen. Bitte erneut versuchen.' };
        var message = Object.prototype.hasOwnProperty.call(labels, state.state) ? labels[state.state] : labels.new;
        var label = status.querySelector('[role="status"]');
        text(label, message);
        label.hidden = !message;
      }
      window.addEventListener('sbc:planning-status', update);
      if (window.sbcPlanningStatus) update({ detail: window.sbcPlanningStatus });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
